import * as React from "react";
import  './styles/Title.scss';
import {CSSTransition} from "react-transition-group";


interface Props {
    animate: boolean;
    title: string;
    subtitle?: string;
    children?: any;
    fontSmall?: boolean;
}


const Title: React.FC<Props> = ({children, animate, title, subtitle, fontSmall}) => {
    const titleClass = fontSmall ? "title-content smallFont" : "title-content";
    return (
        <div className={"header " + titleClass}>
            <div className={"titleContainer"}>
               <span className={"title"}>
                        {
                            title
                        }
                    </span>
            </div>
            {subtitle &&(
                <div className={"titleContainer"}>
                    <CSSTransition in={animate} timeout={1500} classNames={{enter: "title-enter", enterActive: "title-enter-active"}} mountOnEnter unmountOnExit>
                    <span className={"subtitle"}>
                        {
                            subtitle
                        }
                    </span>
                    </CSSTransition>
                </div>
            )}
        </div>
    )
}

export default Title;